import Vue from 'vue';
import fundSearch from './fund-search/fund-search.vue';
Vue.component('fund-search', fundSearch);
